import { AppRolesValuesType, AuthDataType } from "utils/Types";
import { APP_ROLES } from "utils/Constants";
import moment from "moment";

const AuthHelper = {
  AUTH_VAR: "auth",
  SESSION_EXPIRE_TIME: "_srs_login_timeout_time",
  TOKEN_EXPIRE_TIME: "_srs_access_token_timeout_time",
  SHOW_REFRESH_TOKEN_WIP: "SHOW_REFRESH_TOKEN_WIP",
  setAuth: (authData: AuthDataType): void => {
    localStorage.setItem(AuthHelper.AUTH_VAR, JSON.stringify(authData));
    window.dispatchEvent(new Event("storage"));
  },
  getAuth: (): any => {
    const val = localStorage.getItem(AuthHelper.AUTH_VAR);
    return val ? JSON.parse(val) : null;
  },
  getRefreshToken: (): string => {
    const auth = AuthHelper.getAuth();
    return auth?.refreshToken ? auth.refreshToken : "";
  },
  extendTimeout: (extendTokenTimeOut: boolean): void => {
    const val = localStorage.getItem(AuthHelper.AUTH_VAR);
    const data = val ? JSON.parse(val) : null;
    if (data) {
      const newTimeout = moment().add(data.expiresIn, "seconds");
      localStorage.setItem(AuthHelper.SESSION_EXPIRE_TIME, newTimeout.format());
      if (extendTokenTimeOut) {
        localStorage.setItem(AuthHelper.TOKEN_EXPIRE_TIME, newTimeout.format());
      }
    }
  },
  getUserName: (): string => {
    const auth = AuthHelper.getAuth();
    if (!auth || !auth.accessToken || !auth.roles) {
      return "";
    }
    return auth.username;
  },
  getEmail: (): string => {
    const auth = AuthHelper.getAuth();
    if (!auth || !auth.accessToken || !auth.roles) {
      return "";
    }
    return auth.attributes.data.email;
  },
  getAttributes: () => {
    const auth = AuthHelper.getAuth();
    if (!auth || !auth.accessToken || !auth.roles) {
      return "";
    }
    return auth.attributes.data;
  },
  setRole: (newRoles: Array<AppRolesValuesType>): void => {
    const val = AuthHelper.getAuth();
    if (val) {
      const copiedVal = JSON.parse(JSON.stringify(val));
      copiedVal.roles = newRoles;
      localStorage.setItem(AuthHelper.AUTH_VAR, JSON.stringify(copiedVal));
    }
  },
  setUserName: (newEmail: string): void => {
    const val = AuthHelper.getAuth();
    if (val) {
      const copiedVal = JSON.parse(JSON.stringify(val));
      copiedVal.username = newEmail;
      localStorage.setItem(AuthHelper.AUTH_VAR, JSON.stringify(copiedVal));
    }
  },
  toggleRefreshTokenWIP: (newState: boolean): void => {
    localStorage.setItem(AuthHelper.SHOW_REFRESH_TOKEN_WIP, newState.toString());
  },
  clearAuth: (): void => {
    localStorage.removeItem(AuthHelper.AUTH_VAR);
    localStorage.removeItem(AuthHelper.SESSION_EXPIRE_TIME);
    window.dispatchEvent(new Event("storage"));
  },
  isAuthed: (): any => {
    const authObj = AuthHelper.getAuth();
    return authObj && authObj.accessToken;
  },
  getRoles: (): Array<AppRolesValuesType> => {
    const auth = AuthHelper.getAuth();
    if (!auth || !auth.accessToken || !auth.roles) {
      return [];
    }
    return auth.roles;
  },
  hasAnyRoles: (roles: Array<AppRolesValuesType>): boolean => {
    const auth = AuthHelper.getAuth();

    if (!auth || !auth.accessToken || !auth.roles) {
      return false;
    }

    // Based on the case has single role from api
    return auth.roles.reduce(
      (previous: AppRolesValuesType, current: AppRolesValuesType) =>
        previous || roles.includes(current),
      false
    );
  },
  hasBothRoles: (): any => {
    return AuthHelper.hasAnyRoles([APP_ROLES.ADMIN]) && AuthHelper.hasAnyRoles([APP_ROLES.SRS]);
  },
  isAdmin: (): boolean => AuthHelper.hasAnyRoles([APP_ROLES.ADMIN]),
  isEAS: (): boolean => AuthHelper.hasAnyRoles([APP_ROLES.EAS]),
  isSRS: (): boolean => AuthHelper.hasAnyRoles([APP_ROLES.SRS]),
  isSchoolUser: (): boolean =>
    AuthHelper.hasAnyRoles([APP_ROLES.ADMIN, APP_ROLES.SRS, APP_ROLES.EAS]),
  isUnencrypted: (): boolean => AuthHelper.hasAnyRoles([APP_ROLES.UNENCRYPTED])
};

export default AuthHelper;
